export default "__VITE_ASSET__BwCpRQaL__"